import {ROUTES} from '@/utils/constants/routesConstants';
import {useMain} from '@/hooks/useMain';
import {useOktaStorage} from '@/hooks/useOktaStorage';
import {useEffect} from 'react';
import {useIntl} from 'react-intl';
import {useLocation, useNavigate} from 'react-router-dom';

export const Home = () => {
  const {formatMessage} = useIntl();
  const {
    claims: {FirstName}
  } = useOktaStorage();

  const navigate = useNavigate();
  const {pathname} = useLocation();

  useMain();

  useEffect(() => {
    if (pathname === ROUTES.HOME) {
      navigate(ROUTES.SALES_TARGETS);
    }
  }, [navigate, pathname]);

  return (
    <div className='flex flex-col'>
      <p className='mb-4 text-3xl font-bold' data-cy='welcome-message'>
        {formatMessage(
          {id: 'NBA_LIST.WELCOME_MESSAGE'},
          {
            userName: FirstName || 'User'
          }
        )}
      </p>
    </div>
  );
};
